'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Controller($scope, $filter, $stateParams, AppConstants, CityComponent, LineComponent, PageHeading, SubLineComponent, PromotionComponent, Toast) {
	'ngInject';

	var vm = this;

	vm.promotionComponent = 'subLines';
	vm.getLines = LineComponent.getLines;
	vm.addComponent = addComponent;
	vm.fetchLines = LineComponent.fetchLines;
	vm.getLinesPaginationInfo = LineComponent.getPaginationInfo();
	vm.searchCities = CityComponent.searchCities;
	vm.getResultSearchCities = CityComponent.getResultSearchCities;
	vm.getSubLines = SubLineComponent.getSubLines;
	vm.clearResults = CityComponent.clearResultSearchCities;
	vm.selectFromCity = selectFromCity;
	vm.selectToCity = selectToCity;
	vm.searchSubLines = searchSubLines;
	vm.getPaginationInfo = SubLineComponent.getPaginationInfo;
	vm.fromCity = {};
	vm.toCity = {};
	vm.promotionId = $stateParams.promotionId;

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.EDITING_PROMOTION_LINES');
		var title = 'BTMS | ' + $filter('translate')('HEADING.EDITING_PROMOTION_LINES');

		PageHeading.setPageHeading(heading, title);
	}

	function selectFromCity(city) {
		vm.queryFrom = city.translation.name;
		vm.fromCity = city;
	}

	function selectToCity(city) {
		vm.queryTo = city.translation.name;
		vm.toCity = city;
	}

	function searchSubLines(page, fromCityId, toCityId) {
		var hasErrors = false;

		angular.forEach($scope.searchSubLines.$error.required, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		var params = {
			'from_city_id': fromCityId,
			'to_city_id': toCityId
		};

		SubLineComponent.fetchSubLines(params, page, $stateParams.promotionId).then(function (res) {
			if (res.data && res.data.errors) {
				Toast.responseError(res.data.errors);
			} else if (!res.length) {
				Toast.info($filter('translate')('NOT_FOUND.SUB_LINES'));
			}
		});
	}

	function addComponent(componentId, componentType) {
		PromotionComponent.addComponent($stateParams.promotionId, componentId, componentType).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				if (componentType === 'line') {
					Toast.success($filter('translate')('SUCCESS.LINE_ADDED_TO_PROMOTION'));
					LineComponent.fetchLines(vm.getLinesPaginationInfo.page, $stateParams.promotionId);
				} else {
					Toast.success($filter('translate')('SUCCESS.SUB_LINE_ADDED_TO_PROMOTION'));
					searchSubLines(vm.getPaginationInfo().page, vm.fromCity.id, vm.toCity.id);
				}
			}
		});
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/promotions/edit-lines/add/add.controller.js
 **/